<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Sumber Anggaran</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>




            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->

                <br>
                

            <div class="row" style="background: gray">
                <br>
                <div class="col-md-6">
                    <select class="form-control show-tick" tabindex="-98">
                        <option value="" selected disabled>-- Tipe Anggaran --</option>
                        <option value=""></option>
                    </select> <br>
                </div>
            </div>    


                <hr>

            <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info kepala_table_f tabel_center">
                            <th class="text-center" style="width: 3%"></th>
                            <th class="text-center" style="width: 25%">Kode Sumber Anggaran</th>
                            <th class="text-center" style="width: 47%">Kegiatan</th>
                            <th class="text-center" style="width: 25%">Jml Anggaran</th>
                        </tr>
                        </thead>    
                        <tbody class="tabel_center" >
                          <tr class="h_isitable4 " >
                            <td class="tabel_center"></td>
                            <td class="tabel_center"></td>
                            <td class="tabel_center text-center" ></td>
                            <td class="tabel_center text-center" ></td>
                            <!-- <td class="tabel_center text-center" >                        

                                <button @click="selectData(data.kode_urusan, data.nama_urusan, data.id, data._id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp; 
                                <button @click="removeData(data._id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>

                            </td> -->
                          </tr>

                        </tbody>
                    </table>
                </div>

                                            

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>                                      
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                            <form @submit.prevent="addData()">

                                <div class="modal-body">
                                
            <div class="row" >
                <br>
                <div class="col-md-6">
                    <select class="form-control show-tick" tabindex="-98">
                        <option value="" selected disabled>-- Periode RPJMD --</option>
                        <option value="">2016-2021</option>
                    </select> <br>
                </div>
                <div class="col-md-6">
                    <select class="form-control show-tick" tabindex="-98">
                        <option value="" selected disabled>-- Aspek Pembangunan --</option>
                        <option value="">[1] Meningkatnya Pelayanan Publik</option>
                    </select><br>
                </div>
                <div class="col-md-6">
                    <select class="form-control show-tick" tabindex="-98">
                        <option value="" selected disabled>-- Aspek Fokus Pemb --</option>
                        <option value="">[1] Meningkatnya Pelayanan Publik</option>
                    </select><br>
                </div>
                <div class="col-md-6">
                    <select class="form-control show-tick" tabindex="-98">
                        <option value="" selected disabled>-- Bidang Urusan --</option>
                        <option value="">[1] Meningkatnya Pelayanan Publik</option>
                    </select><br>
                </div>

                
            </div>    

                                <div class="table-responsive">
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info kepala_table_f text-center">
                                            <th class="tabel_center text-center" rowspan="2" style="width: 5%">No.</th>
                                            <th class="tabel_center text-center" rowspan="2" style="width: 5%"> </th>
                                            <th class="tabel_center text-center" rowspan="2" style="width: 70%">Uraian Indikator</th>
                                            <th class="tabel_center text-center" rowspan="2" style="width: ">Satuan</th>
                                            <th class="tabel_center text-center" rowspan="2" style="width: ">Rumusan Satuan</th>

                                            <th class="tabel_center text-center" style="width: " colspan="8">Target</th>

                                            <th class="tabel_center text-center" rowspan="2" style="width: 5%">#</th>
                                        </tr>
                                        <tr class="bg-info kepala_table_f text-center">
                                            <th class="tabel_center text-center" style="width: ">Capaian Awal</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 1</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 2</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 3</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 4</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 5</th>
                                            <th class="tabel_center text-center" style="width: ">Tahun Ke 6</th>
                                            <th class="tabel_center text-center" style="width: ">Kondisi Akhir</th>
                                        </tr>
                                    </thead>
                                        <tbody>
                                        <tr class="h_isitable4" >
                                            <td class="tabel_center text-center">1.</td>
                                            <td class="tabel_center text-center"> <input type="checkbox" id="checkbox1" name="checkbox"><label for="checkbox1">Pilih</label> </td>
                                            <td class="tabel_center" >Meningkatnya Pelayanan Publik</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                            <td class="tabel_center text-center">1</td>
                                                
                                            <td class="tabel_center text-center" >
                                                <button @click="removeData(data._id)" type="button" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>                                              

                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>                                    

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>                                      
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">
                                
                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Periode RPJMD</label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="10">2016 - 2021</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                

                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Misi</label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="">-- Pilih Misi --</option>
                                            <option value="10">[1] Meningkatnya Pelayanan Publik</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                    

                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Sasaran </label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="">-- Pilih Sasaran --</option>
                                            <option value="10">[2] Urusan Pemerintahan Fungsi Penunjang Pengawasan</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                  



                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Bidang Urusan</label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="">-- Pilih Bidang Urusan --</option>
                                            <option value="">[101] Urusan Wajib Pelayanan Dasar Pendidikan</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                

                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Program Pembangunan</label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="">-- Uraian Program --</option>
                                            <option value="">[0101.01] Program Pelayanan Administrasi Perkantoran</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                   

                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Prioritas Program</label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select class="form-control show-tick" tabindex="-98">
                                            <option value="">-- Pilih Prioritas Program --</option>
                                            <option value="">Prioritas I</option>
                                            <option value="">Prioritas II</option>
                                            <option value="">Prioritas III</option>                                                                                        
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>                                   

                                <div class="row clearfix">
                                    <div class="col-md-3 form-control-label">
                                        <label for="kode">Keterangan </label>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <textarea rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/urusan/';


    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                },
                kode_urusan: '',
                nama_urusan: '',
                id_urusan: '',
                list_urusan: [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'create', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'read', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_urusan = data_urusan.data;
                  this.page_last = data_urusan.jml_data;
                })
            },
            editData: function(){
                fetch(ADD_URL+'update', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kode_urusan: this.kode_urusan,
                        nama_urusan: this.nama_urusan,
                        id_urusan: this.id_urusan,
                        _id: this._id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(kode_urusan, nama_urusan, id, _id){
                this._id = _id;
                this.id_urusan = id;
                this.kode_urusan = kode_urusan;
                this.nama_urusan = nama_urusan;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                };
                this.kode_urusan= '';
                this.nama_urusan= '';
                this.id_urusan= '';
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
